<template>
  <div class="flex flex-col w-full">
    <div>
      <p class="block w-full text-lg font-medium">Images</p>
    </div>
    <div class="flex flex-row flex-wrap">
      <div
        class="flex flex-col m-3"
        v-for="(imgObj, index) in images"
        :key="index + '-img'"
        v-show="imgObj.deleted == false"
      >

        <div
          v-if="!disabled"
          :class="{'border-blue-500 border-2': index === 0}"
          class="relative flex flex-col justify-center flex-grow image group"
        >
          <div class="absolute items-center justify-center hidden w-full h-full border-blue-500 group-hover:flex group-hover:border">
            <div class="absolute w-full h-full bg-gray-500 opacity-25"></div>
            <div>

            </div>
            <p
              v-if="index !== 0"
              @click="setMainPic(index)"
              class="z-10 px-2 py-1 text-white bg-gray-600 rounded-lg shadow-md opacity-100 cursor-pointer hover:shadow-sm"
            >
              Make Thumbnail
            </p>
            <font-awesome-icon
              @click="removePic(index)"
              :class="[disabled ? 'text-gray-700' : 'text-red-700 cursor-pointer']"
              class='absolute top-0 right-0 z-10 m-1 cursor-pointer '
              icon="trash"
            />
          </div>

          <img
            :src="imgObj.base64"
            class="object-scale-down w-40 h-32"
          />
        </div>

      </div>

      <!-- Image button -->
      <select-images
        v-if="images != undefined"
        :images.sync="images"
        :disabled="disabled"
        :error="!filesIsValid"
      />

    </div>
  </div>
</template>

<script>

import SelectImages from './SelectImages.vue';

const cloneDeep = require('lodash.clonedeep');

export default {
  name: 'item-image',
  components: {
    SelectImages,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    filesIsValid: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    removePic(index) {
      if (this.images.length == 0 || this.disabled) return;
      const modifiedImages = cloneDeep(this.images);
      modifiedImages[index].deleted = true;
      this.$emit('update:images', modifiedImages);
    },
    setMainPic(index) {
      if (this.disabled) return;
      const newArray = [];
      const newMain = this.images[index];
      newArray.push(newMain);
      this.images.forEach((img, i) => {
        if (i != index) newArray.push(img);
      });
      this.updateImageProp(newArray);
    },
    updateImageProp(newVal) { this.$emit('update:images', newVal); },

  },
};
</script>
